import PropTypes from 'prop-types';
import { useOfficeReviewsV2 } from '../../../../hooks/useOfficeReviewsV2';
import UserReview from '../UserReview';
import { OfficeReviews } from './OfficeReviews';

/**
 * The office profile's Reviews tab, gated on GOTU-6266.
 *
 * `OfficeReviews` reads organization-service, which has not shipped, so until
 * it does an office profile has to fall back to the monolith table it had
 * before GOTU-7338 — `UserReview` with `isOffice`, which drops the three
 * professional-skill columns the monolith only scores in the other direction.
 *
 * **The branch is here, above `OfficeReviews`, and that placement is the whole
 * point.** `useGetOfficeReviews` is a React Query hook and so cannot be called
 * conditionally; gating inside `OfficeReviews` would fire the request and only
 * then decide not to show it, which is exactly what the flag exists to stop.
 * Choosing which component mounts means the flag-off path never reaches
 * organization-service at all.
 *
 * A component rather than a branch at the call site because `Profile.js` is a
 * class and cannot read a hook. It stays a thin switch: no data, no layout.
 *
 * Retire this file with the flag — `Profile.js` then renders `OfficeReviews`
 * directly again.
 */
export const OfficeReviewsTabScreen = ({ officeId, goToJobProfile }) => {
  const isOfficeReviewsV2Enabled = useOfficeReviewsV2();

  if (!isOfficeReviewsV2Enabled) {
    return <UserReview goToJobProfile={goToJobProfile} isOffice />;
  }

  return <OfficeReviews officeId={officeId} />;
};

OfficeReviewsTabScreen.propTypes = {
  /** The office whose reviews to list. Absent while the profile resolves. */
  officeId: PropTypes.string,
  /** Legacy-table only: opens a shift from its "View Job" cell. */
  goToJobProfile: PropTypes.func,
};

OfficeReviewsTabScreen.defaultProps = {
  officeId: undefined,
  goToJobProfile: () => {},
};

export default OfficeReviewsTabScreen;
